export function getOptions(statuses, is_subset, subset) {
  return statuses.filter(({ type }) => !is_subset || subset.includes(type))
}
